import { createContext, useContext } from 'react';
import { createStore, useStore } from 'zustand';
import { BBox } from '../modelAreaCoordinates.utils';

interface ModelAreasState {
  bbox: BBox | null;
  editing: boolean;
}

interface ModelAreasActions {
  setBbox: (bbox: BBox | null) => void;
  setEditing: (editing: boolean) => void;
  reset: () => void;
}

export type ModelAreasStore = ModelAreasState & ModelAreasActions;

const INITIAL: ModelAreasState = { bbox: null, editing: false };

export function createModelAreasStore() {
  return createStore<ModelAreasStore>((set) => ({
    ...INITIAL,
    setBbox: (bbox) => set({ bbox }),
    setEditing: (editing) => set({ editing }),
    reset: () => set(INITIAL),
  }));
}

type StoreApi = ReturnType<typeof createModelAreasStore>;

export const ModelAreasStoreContext = createContext<StoreApi | null>(null);

export function useModelAreasStore<T>(
  selector: (state: ModelAreasStore) => T,
): T {
  const store = useContext(ModelAreasStoreContext);
  if (!store) throw new Error('useModelAreasStore: missing provider');
  return useStore(store, selector);
}
